import { Sparkles, Palette, Layers, ShoppingBag, LucideIcon } from "lucide-react";

export interface ProcessStep {
  icon: LucideIcon;
  title: string;
  shortDescription: string; // For compact version
  description: string; // For full version
  color: string;
  bgColor: string;
  details: string[];
}

export const PROCESS_STEPS: ProcessStep[] = [
  {
    icon: Sparkles,
    title: "Define",
    shortDescription: "Choose your product and style",
    description: "Choose your product type and style from our curated catalog",
    color: "text-blue-500",
    bgColor: "bg-blue-500/10",
    details: [
      "Browse our product catalog",
      "Select size and variants",
      "Pick your preferred materials",
      "Set quantity preferences",
    ],
  },
  {
    icon: Palette,
    title: "Refine",
    shortDescription: "Create & refine with AI",
    description: "Use AI to create & refine your brilliant idea from a simple prompt",
    color: "text-purple-500",
    bgColor: "bg-purple-500/10",
    details: [
      "Describe your vision in words",
      "AI generates multiple options",
      "Refine with follow-up prompts",
      "Perfect your design iteratively",
    ],
  },
  {
    icon: Layers,
    title: "Align",
    shortDescription: "Position your design perfectly",
    description: "Position and adjust your design perfectly on the product",
    color: "text-green-500",
    bgColor: "bg-green-500/10",
    details: [
      "Live product preview",
      "Drag and drop positioning",
      "Resize and scale design",
      "See exactly what you'll get",
    ],
  },
  {
    icon: ShoppingBag,
    title: "Enshrine",
    shortDescription: "Finalize and order",
    description: "Finalize your creation and bring it to life with premium printing",
    color: "text-orange-500",
    bgColor: "bg-orange-500/10",
    details: [
      "Review final product mockup",
      "Add to cart for checkout",
      "Fast, reliable shipping",
      "Premium quality guarantee",
    ],
  },
];
